import { useEffect } from "react";
import { Link } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import useReveal from "@/hooks/useReveal";
import { setPageSEO } from "@/lib/seo";
import Header from "@/components/landing/Header";
import Footer from "@/components/landing/Footer";
import WhatsAppFloat from "@/components/landing/WhatsAppFloat";
import SubpageHero from "@/components/landing/SubpageHero";
import WhatEOSAchieves from "@/components/landing/WhatEOSAchieves";
import SixComponents from "@/components/landing/SixComponents";
import FAQ from "@/components/landing/FAQ";
import FinalCTA from "@/components/landing/FinalCTA";

export default function QueEsEOS() {
  useReveal();

  useEffect(() => {
    setPageSEO({
      title: "¿Qué es EOS? | Entrepreneurial Operating System | Carlos Garcín Chile",
      description: "Descubre qué es EOS (Entrepreneurial Operating System) y por qué más de 34.000 empresas en el mundo lo usan para escalar. Carlos Garcín, Chile.",
      path: "/que-es-eos",
      keywords: "qué es EOS, Entrepreneurial Operating System, metodología EOS, EOS Chile, EOS Worldwide",
    });
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Header />
      <main>
        <SubpageHero
          eyebrow="EOS — Entrepreneurial Operating System"
          title="¿Qué es EOS y cómo puede transformar tu empresa?"
          subtitle="Una metodología simple, práctica y comprobada que ayuda a empresarios y sus equipos de liderazgo a escalar con foco, alineamiento y disciplina."
          withCta
        />
        <WhatEOSAchieves />
        <SixComponents />
        <FAQ />

        <section className="py-12 bg-white border-t border-slate-100">
          <div className="container-eos max-w-3xl">
            <div className="reveal">
              <p className="text-slate-600 text-base sm:text-lg leading-relaxed">
                Entender qué es EOS es el primer paso. El siguiente es conocer cómo se lleva a la práctica dentro de tu empresa.
              </p>
              <Link
                to="/implementador-eos"
                data-testid="que-es-eos-implementador-link"
                className="mt-4 inline-flex items-center gap-1.5 text-[#F26522] font-semibold hover:underline"
              >
                Te cuento cómo implemento EOS →
              </Link>
            </div>
          </div>
        </section>

        <FinalCTA />
      </main>
      <Footer />
      <WhatsAppFloat />
      <Toaster position="top-right" />
    </>
  );
}
